<template>
  <div id="app">
    <!-- <keep-alive>
      <router-view v-if="$route.meta.keepAlive"/>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"/> -->
    <router-view/>
    <div class="system-notice" v-if="showSystem&&isUsercenterSite">
      <div class="header centerS">
        <span></span>
        系统提示
        <span class="iconfont icon-guanbi" @click="showSystem=false"></span>
      </div>
      <div class="wenzi">
        <p style="line-height:36px;font-weight: bold;font-size:18px;color:#505359;">尊敬的用户您好!</p>
        <p style="color:#5C5F66;" v-html="msgContent"></p>
        <div class="center" style="margin-top:30px;">
          <el-button type="primary" size="mini" @click="showSystem=false">关闭</el-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getSysNotice,
} from "@/api/notice/index"
import {mapMutations} from "vuex";

export default {
  name: 'app',
  data() {
    return {
      showSystem: false
    }
  },
  computed: {
    isUsercenterSite(){
      let site = ['MySubs','MyCollect','myMessage','newsManage','algorithmApproval','productApproval',
      'satelliteDataApproval','noticeManage','systemNotice']
      return !site.includes(this.$route.name)
    }
  },
  methods: {
    ...mapMutations(['SET_theme']),
    async getNewSysNotice() {
      let that = this
      let res = await getSysNotice({
        page: 1,
        limit: 1,
        validFlag: 1
      })
      if (res.data && res.data.list && res.data.list.length > 0) {
        that.showSystem = true
        that.msgContent = res.data.list[0].msg
      }
    },
    getUser() {
      this.$store.dispatch('getShopTotal')
      this.$store.dispatch('getMessageTotal')
    },
    handleMessage2(event) {
      if (event.data.router) {
        this.$router.push({
          path: '/product-detail', query: {
            ProductId: event.data.router.productId
          }
        })
        return
      }
    }
  },
  mounted() {
    window.addEventListener("message", this.handleMessage2);

    const language = window.localStorage.getItem('language')
    if (language) {
      this.$i18n.locale = language;
    } else {
      this.$i18n.locale = 'zh';
    }

  },
  created() {
    window.document.documentElement.setAttribute('data-theme', 'theme2')
    this.SET_theme('theme2')
    this.getUser()
    this.getNewSysNotice()
    if(this.$route.query.lang){
      if(this.$route.query.lang==="zh-CN"){
        window.localStorage.setItem('language', 'zh')
        this.$i18n.locale = 'zh';
      }else if(this.$route.query.lang==="en-US"){
        window.localStorage.setItem('language', 'en')
        this.$i18n.locale = 'en';
      }
      let newQuery = JSON.parse(JSON.stringify(this.$route.query)) // 先拷贝一个一模一样的对象
      delete newQuery.lang //再删除lang
      this.$router.replace({ query: newQuery })
    }
  }
}
</script>

<style>
#app {
  /* text-align: center; */
  width: 100%;
  height: 100%;
}

html, body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}

.iclient-leaflet-logo, .leaflet-control-attribution {
  display: none;
}
</style>

<style lang="scss" scoped>
.system-notice {
  position: fixed;
  left: 31px;
  top: 212px;
  z-index: 10000;

  width: 356px;
  height: 289px;
  background: rgba(247, 251, 255, 0.95);
  box-shadow: 0px 4px 7px 0px rgba(8, 18, 27, 0.08);
  border-radius: 10px;

  .icon-guanbi {
    cursor: pointer;
  }

  .wenzi {
    padding: 24px;
  }

  .header {
    width: 308px;
    height: 48px;
    padding: 0 24px;
    background: linear-gradient(0deg, #247EE5, #3390F8);
    border-radius: 10px 10px 0px 0px;

    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #FFFFFF;
    line-height: 41px;
    text-shadow: 0px 1px 2px rgba(16, 94, 179, 0.6);
  }
}
</style>
